import { LANE_STEP } from './consts.js';
export function formatElapsedSinceStart(elapsedMs) {
    const ms = Math.max(0, elapsedMs);
    const totalSec = Math.floor(ms / 1000);
    const h = Math.floor(totalSec / 3600);
    const m = Math.floor((totalSec % 3600) / 60);
    const s = totalSec % 60;
    if (h > 0) {
        return `${h}h ${String(m).padStart(2, '0')}m`;
    }
    if (m > 0) {
        return `${m}m ${String(s).padStart(2, '0')}s`;
    }
    return `${s}s`;
}
export function getMarkerCenterPx(m, encounterStart, spanMs, trackY, chartLeft, plotWidthPx, laneStep = LANE_STEP) {
    const xNorm = spanMs > 0 ? (m.timeMs - encounterStart) / spanMs : 0;
    const x = chartLeft + Math.max(0, Math.min(1, xNorm)) * plotWidthPx;
    const y = trackY - m.lane * laneStep - 4;
    return { x, y };
}
//# sourceMappingURL=eventsTimelineHelpers.js.map